import AutomationPostModalAdditionalDetails from './AutomationPostModalAdditionalDetails';

export default AutomationPostModalAdditionalDetails;
